import { Button, Typography, Modal, BUTTON_VARIANT } from '@sanlam-glacier/app-common/components';
import { useState } from 'react';
import { Theme } from 'components/atoms/theme/Theme';

type ProposalPromptProps = {
  action: (() => () => Promise<void>) | undefined;
  isPromptOpen: boolean;
  title: string;
  promptText1: string;
  promptText2: string;
  primaryButtonText: string;
  secondaryButtonText: string;
  setIsPromptOpen: (state: boolean) => void;
};
export const ProposalPrompt = (props: ProposalPromptProps) => {
  const [isLoading, setIsLoading] = useState(false);
  return (
    <Modal
      onClose={() => props.setIsPromptOpen(false)}
      open={props.isPromptOpen}
      inlineHeader={true}
      size={Modal.SIZE.LARGE}
      backdrop={'static'}
      title={
        <Typography
          align={Typography.ALIGN.LEFT}
          variant={Typography.VARIANT.H3}
          weight={Typography.WEIGHT.NORMAL}
        >
          {props.title}
        </Typography>
      }
      primaryButton={
        <Theme variant='secondary'>
          <Button
            onClick={async () => {
              if (props.action) {
                setIsLoading(true);
                await props.action();
                setIsLoading(false);
              }

              props.setIsPromptOpen(false);
            }}
            disabled={isLoading}
          >
            {props.primaryButtonText}
          </Button>
        </Theme>
      }
      secondaryButton={
        <Theme variant='secondary'>
          <Button
            disabled={isLoading}
            variant={BUTTON_VARIANT.SECONDARY}
            onClick={() => props.setIsPromptOpen(false)}
          >
            {props.secondaryButtonText}
          </Button>
        </Theme>
      }
    >
      <p>{props.promptText1}</p>
      <br />
      <p>{props.promptText2}</p>
    </Modal>
  );
};
